// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-details-box {
  /* border-radius: 10px; */
  /* box-shadow: 0 1px 2px 0 #00000033, 0 1.5px 5px 0 #00000030; */
  height: 100%;
  cursor: pointer;
  box-shadow: none;
  border: none;
}

.order-details-box-list {
  border-radius: 0px;
  /* box-shadow: 0 1px 2px 0 #00000033, 0 1.5px 5px 0 #00000030; */
  box-shadow: none;
  height: 100%;
  cursor: pointer;
  --bs-card-border-width: 0px;
  border-bottom: 1px solid #eeeeee;
}
.order-details-box-list:hover {
  background-color: #f7f7f7;
}

.order-details-row {
  border: none;
}

.order-details-border {
  border-bottom: 1px solid black;
}

.order-details-delivered-text {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #707070;
}

.order-details-shop-text {
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 16px;
  text-align: end;
  color: black;
}

.order-details-rating-text {
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: black;
}

.good-review-star {
  color: yellow;
}

.loved-it-review-star {
  color: #28af4b;
}

.order-details-price-headings {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 16px;
  text-wrap: nowrap;
}

.order-details-green-text {
  color: #28af4b;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
}

.order-details-total {
  background-color: #d4e5d8;
}
.order-details-dotted-border {
  border-bottom: 2px solid black;
  border-bottom-style: dashed;
}
.order-details-back-button {
  background-color: transparent;
  border: 1px solid #28af4b;
  color: #28af4b !important;
  border-radius: 5px;
  padding: 2px 12px;
  font-family: Manrope;
  /* width: 100%; */
}

.invoice-btn {
  background-color: #28af4b;
  color: white;
  border-radius: 5px;
  padding: 2px 12px;
  font-family: Manrope;
  border: none;
}
.invoice-btn:hover {
  background-color: transparent;
  border: 1px solid #28af4b;
  color: #28af4b !important;
}

.order-details-back-button:hover {
  background-color: #28af4b;
  color: white !important;
}

.table-invoice {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/OrderDetails/OrderDetails.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gEAAgE;EAChE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;EAChE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".order-details-box {\r\n  /* border-radius: 10px; */\r\n  /* box-shadow: 0 1px 2px 0 #00000033, 0 1.5px 5px 0 #00000030; */\r\n  height: 100%;\r\n  cursor: pointer;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n.order-details-box-list {\r\n  border-radius: 0px;\r\n  /* box-shadow: 0 1px 2px 0 #00000033, 0 1.5px 5px 0 #00000030; */\r\n  box-shadow: none;\r\n  height: 100%;\r\n  cursor: pointer;\r\n  --bs-card-border-width: 0px;\r\n  border-bottom: 1px solid #eeeeee;\r\n}\r\n.order-details-box-list:hover {\r\n  background-color: #f7f7f7;\r\n}\r\n\r\n.order-details-row {\r\n  border: none;\r\n}\r\n\r\n.order-details-border {\r\n  border-bottom: 1px solid black;\r\n}\r\n\r\n.order-details-delivered-text {\r\n  font-family: \"Manrope\", sans-serif;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  color: #707070;\r\n}\r\n\r\n.order-details-shop-text {\r\n  font-family: \"Manrope\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  text-align: end;\r\n  color: black;\r\n}\r\n\r\n.order-details-rating-text {\r\n  font-family: \"Manrope\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: black;\r\n}\r\n\r\n.good-review-star {\r\n  color: yellow;\r\n}\r\n\r\n.loved-it-review-star {\r\n  color: #28af4b;\r\n}\r\n\r\n.order-details-price-headings {\r\n  font-family: \"Manrope\", sans-serif;\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  text-wrap: nowrap;\r\n}\r\n\r\n.order-details-green-text {\r\n  color: #28af4b;\r\n  font-weight: 700;\r\n  font-family: \"Manrope\", sans-serif;\r\n  font-size: 16px;\r\n}\r\n\r\n.order-details-total {\r\n  background-color: #d4e5d8;\r\n}\r\n.order-details-dotted-border {\r\n  border-bottom: 2px solid black;\r\n  border-bottom-style: dashed;\r\n}\r\n.order-details-back-button {\r\n  background-color: transparent;\r\n  border: 1px solid #28af4b;\r\n  color: #28af4b !important;\r\n  border-radius: 5px;\r\n  padding: 2px 12px;\r\n  font-family: Manrope;\r\n  /* width: 100%; */\r\n}\r\n\r\n.invoice-btn {\r\n  background-color: #28af4b;\r\n  color: white;\r\n  border-radius: 5px;\r\n  padding: 2px 12px;\r\n  font-family: Manrope;\r\n  border: none;\r\n}\r\n.invoice-btn:hover {\r\n  background-color: transparent;\r\n  border: 1px solid #28af4b;\r\n  color: #28af4b !important;\r\n}\r\n\r\n.order-details-back-button:hover {\r\n  background-color: #28af4b;\r\n  color: white !important;\r\n}\r\n\r\n.table-invoice {\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
